import { render } from "./CommissionBarChart.vue?vue&type=template&id=8ed4177e"
import script from "./CommissionBarChart.vue?vue&type=script&lang=js"
export * from "./CommissionBarChart.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/CommissionBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8ed4177e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8ed4177e', __exports__)) {
    api.reload('8ed4177e', __exports__)
  }
  
  module.hot.accept("./CommissionBarChart.vue?vue&type=template&id=8ed4177e", () => {
    api.rerender('8ed4177e', render)
  })

}


export default __exports__